export default __webpack_public_path__ + "static/media/seosonal_preview_badge.7bd2b29a.png";